<template> 
  <modal v-model="show"
         max-width="500"
         :has-padding="false">  
    <div>
      <app-login-type-captive-body @close="show = false"></app-login-type-captive-body>
    </div>
  </modal>  
</template>

<script>
    import AppLoginTypeCaptiveBody from './components/LoginTypeCaptiveBody'
    import Modal from "@/components/generic/Modal";
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            AppLoginTypeCaptiveBody,
            Modal
        },

        data() {
            return {
                show: false
            }
        },

        methods: {
            reset(data){
                this.show = true
                
                EventBus.$emit('RESET_BODY_LOGIN_TYPES_BODY', data)
            },
            resetUpdateLoginTypesHandler() {
                this.show = false;
            }
        },

        mounted() {
            EventBus.$on('UPDATE_LOGIN_TYPES', this.reset)
            EventBus.$on('RESET_UPDATE_LOGIN_TYPES', this.resetUpdateLoginTypesHandler)
        },

        beforeDestroy() {
            EventBus.$off('UPDATE_LOGIN_TYPES', this.reset)
            EventBus.$off('RESET_UPDATE_LOGIN_TYPES', this.resetUpdateLoginTypesHandler)
        },

    }
</script>

<style scoped>
</style>
